// Removed unused import statement
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

const classIsDesktop = 'd-flex flex-column justify-content-center align-items-center w-75 h-75 bg-light border rounded pe-5 mt-3';
const classIsMobile = 'd-flex flex-column justify-content-center align-items-center w-100 h-100 bg-light border rounded pe-5';
const DataConsultFechas = ({fechaInicial, fechaFinal}) => {
    const isDesktop = useMediaQuery({
        query: "(min-width: 761px)",
    });

    return (
        <div className={isDesktop?classIsDesktop:classIsMobile}>
                <h5>Datos de Consulta:</h5>
                <h6>Fecha Inicial: {fechaInicial}</h6>
                <h6>Fecha Final: {fechaFinal}</h6>
        </div>
    )
}

DataConsultFechas.propTypes = {
    fechaInicial: PropTypes.string.isRequired,
    fechaFinal: PropTypes.string.isRequired
};

export default DataConsultFechas